/** Filtros (server-side) da listagem de Vídeos de uma Série. */
export interface SerieVideoFilters {
  readonly search: string;
  readonly page: number;
}

export const INITIAL_SERIE_VIDEO_FILTERS: SerieVideoFilters = { search: '', page: 1 };
